<app-auth-shell title="Entre na sua conta">
  <form class="auth-login__form" role="form" [formGroup]="formSignin" (ngSubmit)="signin()" novalidate>
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formSignin.get('email')?.dirty) { @if (formSignin.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formSignin.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <div class="auth-field">
      <div class="auth-login__label-row">
        <label class="auth-field__label" for="password">Senha</label>
        <a class="auth-link" [routerLink]="['/forgot']">Esqueci minha senha</a>
      </div>
      <div class="auth-field__control">
        <input
          id="password"
          type="password"
          formControlName="password"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Sua senha"
          autocomplete="current-password"
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye"></i></span>
        </button>
      </div>
      @if (formSignin.get('password')?.dirty) { @if (formSignin.get('password')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } }
    </div>
    <button type="submit" class="auth-btn" [disabled]="!formSignin.valid">Entrar</button>
  </form>
  <div class="auth-login__divider"><span>ou</span></div>
  <div class="auth-login__social">
    <div class="social-login-btn">
      <button type="button" class="auth-social__btn social-login-btn__visible" tabindex="-1" aria-hidden="true">
        <i class="fab fa-google auth-social__google"></i>
        Entrar com Google
      </button>
      <div id="google-btn-container" class="social-login-btn__overlay" aria-label="Entrar com Google"></div>
    </div>
    <button type="button" class="auth-social__btn" (click)="loginWithFacebook()">
      <i class="fab fa-facebook-f auth-social__facebook"></i>
      Entrar com Facebook
    </button>
  </div>
  <div class="auth-login__divider"><span>sem senha</span></div>
  <nav class="auth-login__methods" aria-label="Entrar sem senha">
    <a class="auth-social__btn" [routerLink]="['/magic-link']">
      <i class="fas fa-link auth-login__method-icon"></i>
      Link no e-mail
    </a>
    <a class="auth-social__btn" [routerLink]="['/otp']">
      <i class="fas fa-envelope auth-login__method-icon"></i>
      Código no e-mail
    </a>
    <a class="auth-social__btn" [routerLink]="['/whatsapp']">
      <i class="fab fa-whatsapp auth-login__whatsapp"></i>
      Código no WhatsApp
    </a>
  </nav>
  <p class="auth-login__signup" authShellFooter>
    Não tem uma conta?
    <a [routerLink]="['/signup']">Cadastre-se</a>
  </p>
</app-auth-shell>
